import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=3b8f0adf"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=3b8f0adf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports